import { creating, exist, Id } from '@campaign-portal/namespace/common/id';
import { type UserNotificationCategory } from '@campaign-portal/namespace/common/enums';
import { ContractCompany, TotalPartnersData } from '@campaign-portal/namespace/entities/contract-companies/specs';
import { PortalType } from '@campaign-portal/namespace/entities/portals/specs';

export interface ContractCompanyEntityConfig<ID = creating | exist> extends Partial<ContractCompany<ID>> {
	id: ID;
}

export class ContractCompanyEntity<ID = creating | exist> implements ContractCompany<ID> {
	[key: string]: unknown;

	readonly creationDate?: string | null;
	readonly createdBy?: string | null;
	readonly lastUpdated?: string | null;
	readonly modifiedBy?: string | null;

	id: ID;
	name: string;
	settings: { [key: string]: unknown };
	isDefault: boolean;
	availableImChannels: Id<exist>[];
	availableCurrencies: Id<exist>[];
	availableSubscriptions: Id<exist>[];
	availablePaySystems: Id<exist>[];
	totalEarn: number;
	totalPartners: TotalPartnersData;
	customTemplateCategories: UserNotificationCategory[];
	domains: Id<exist>[];
	readonly portalPair?: {
		[PortalType.CAMPAIGN_PORTAL]: Id<exist> | null;
		[PortalType.ADMIN_PORTAL]: Id<exist> | null;
	};

	constructor(config: ContractCompanyEntityConfig<ID>) {
		this.creationDate = config.creationDate;
		this.createdBy = config.createdBy;
		this.lastUpdated = config.lastUpdated;
		this.modifiedBy = config.modifiedBy;
		this.id = config.id;
		this.name = config.name ?? '';
		this.settings = config.settings ?? {};
		this.isDefault = config.isDefault ?? false;
		this.availableImChannels = config.availableImChannels ?? [];
		this.availableCurrencies = config.availableCurrencies ?? [];
		this.availableSubscriptions = config.availableSubscriptions ?? [];
		this.availablePaySystems = config.availablePaySystems ?? [];
		this.domains = config.domains ?? [];
		this.totalEarn = config.totalEarn ?? 0;
		this.totalPartners = config.totalPartners ?? { resellers: 0, retailers: 0, total: 0 };
		this.customTemplateCategories = config.customTemplateCategories ?? [];
		this.portalPair = config.portalPair;
	}

	hasChannel(channelId: Id<exist>): boolean {
		return this.availableImChannels.includes(channelId);
	}

	hasPartners(): boolean {
		return this.totalPartners.total > 0;
	}
}
